import { render, staticRenderFns } from "./order1.vue?vue&type=template&id=beb38c06"
import script from "./order1.vue?vue&type=script&lang=js"
export * from "./order1.vue?vue&type=script&lang=js"
import style0 from "./order1.vue?vue&type=style&index=0&id=beb38c06&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports